import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { LocalStorageService } from './local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  userId:any;
  constructor( private router: Router,
    private localStorageService : LocalStorageService
  ) {
   }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    this.userId =  JSON.parse(this.localStorageService.getItem("loginData") || '{}').user_id;
    if (this.userId !=0 && this.userId !=null && this.userId !=undefined && this.userId !='' ) {
      return true;
    }
    this.router.navigate(['/auth/login']);
    localStorage.clear();
    return false;
  }
}
